module.exports = __webpack_public_path__ + "images/close-blue.4495832272e0139f85d6a8164bfece3b.svg";